import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../../actions/auth';
import { createProject, getProjects, setSelectedProject } from '../../../actions/forms';
import Projects from '../../rofburns/Projects';
import BannerHeader from './shared-components/BannerHeader';
import Selections from '../../rofburns/Selections';
import RofDataSelection from './flame-cap-kiln/RofDataSelection';
import CbDataSelection from './conservation-burns/CbDataSelection';
import RofAddProjectDialog from './shared-components/RofAddProjectDialog';
import RofTooltip from './shared-components/RofTooltip';
import tooltips from '../../../store/tooltips';

const BIOCHAR_PRODUCTION_METHODS = [
    'Flame Cap Kiln',
    'Conservation Burns'
]

export default function Programs({ quickLinks }) {
    const dispatch = useDispatch()
    // const location = useLocation();
    const [open, setOpen] = useState(false);
    const [programmeId, setProgrammeId] = useState(1);
    const [projectId, setProjectId] = useState(null);
    const [projectKey, setProjectKey] = useState(null);
    const [projectMeasurementType, setProjectMeasureType] = useState('')
    const [newProjectNickname, setNewProjectNickname] = useState('');
    const { userData } = useSelector(state => state.auth);
    const { projects } = useSelector(state => state.postFormData)
    const [addProjectError, setAddProjectError] = useState('');

    const [selectedCategory, setSelectedCategory] = useState(null)
    const [burnType, setBurnType] = useState('Flame Cap Kiln');
    // const [activeSubItem, setActiveSubItem] = useState('')

    useEffect(() => {
        dispatch(getUserDetails());
    }, [dispatch]);

    useEffect(() => {
        setAddProjectError('')
    }, [open])

    useEffect(() => {
        setSelectedCategory('Data Monitoring')
    }, [burnType])

    useEffect(() => {
        if (userData && userData?.farmId) {
            dispatch(getProjects(userData?.farmId));
        }
    }, [dispatch, userData?.farmId]);

    useEffect(() => {
        if (quickLinks) {
            setProjectId(quickLinks.projectId)
            setProjectKey(quickLinks.projectKey)
        }
        else if (projects.length) {
            setProjectId(projects[0].projectId);
            setProjectKey(projects[0].id)
            setProjectMeasureType(projects[0].measurementType)
            dispatch(setSelectedProject({
                projectId: projects[0].projectId,
                id: projects[0].id,
                measureType: projects[0].measurementType,
                nickname: projects[0].nickname
            })).then(() => {
                setSelectedCategory('Data Monitoring')
                setNewProjectNickname('')
            })
        }
    }, [projects]);

    const handleSubmit = () => {
        setOpen(false);
        if (programmeId)
            dispatch(createProject(userData?.farmId, { programmeId, nickname: newProjectNickname, projectMeasurementType })).then(() => {
                setNewProjectNickname('');
                setProgrammeId(null);
                setAddProjectError('');
            })
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <BannerHeader hasAddButton setOpen={setOpen}>
                Programs
            </BannerHeader>
            <Box sx={{ display: 'flex', flexDirection: 'column', px: 3, gap: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant='h5' component='h5'>
                            Biochar Production Projects
                            <RofTooltip tooltipText={tooltips.projectId} />
                        </Typography>
                        <Typography>
                            Access your created projects - click the card to view them!
                        </Typography>
                    </Box>
                    <Box>
                        <Projects
                            projectKey={projectKey}
                            projects={projects}
                            projectId={projectId}
                            setProjectId={setProjectId}
                            setProjectKey={setProjectKey}
                            setProjectMeasureType={setProjectMeasureType}
                            setNickname={setNewProjectNickname}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant='h5'>Biochar Production Methods</Typography>
                        <Typography>Select your production method</Typography>
                    </Box>
                    <Grid item gap={2} sx={{ display: 'flex' }} >
                        {
                            BIOCHAR_PRODUCTION_METHODS.map((method, index) => (
                                <Button
                                    key={index}
                                    variant={burnType === method ? 'contained' : 'outlined'}
                                    onClick={() => {
                                        setBurnType(method);
                                    }}
                                // disabled={method === 'Conservation Burns'}
                                >
                                    {method}
                                </Button>
                            ))
                        }
                    </Grid>
                </Box>
                {projectKey && burnType &&
                    <Selections
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        burnType={burnType}
                    />
                }
                <Divider />
                {
                    burnType === 'Flame Cap Kiln' &&
                    <RofDataSelection
                        burnType={burnType}
                        selectedCategory={selectedCategory} />
                }
                {
                    burnType === 'Conservation Burns' &&
                    <CbDataSelection
                        burnType={burnType}
                        selectedCategory={selectedCategory} />

                }
                <RofAddProjectDialog
                    open={open}
                    setOpen={setOpen}
                    programmeId={programmeId}
                    setProgrammeId={setProgrammeId}
                    nickname={newProjectNickname}
                    setNickname={setNewProjectNickname}
                    projectMeasurementType={projectMeasurementType}
                    setProjectMeasureType={setProjectMeasureType}
                    addProjectError={addProjectError}
                    setAddProjectError={setAddProjectError}
                    handleSubmit={handleSubmit}
                />
            </Box >
        </Box>
    )
}